document.addEventListener('DOMContentLoaded', function() {
  // Main elements
  const slidesContainer = document.querySelector('.carousel-slides');
  const slides = document.querySelectorAll('.slide');
  const prevBtn = document.querySelector('.prev-btn');
  const nextBtn = document.querySelector('.next-btn');
  
  // Variables
  let currentIndex = 0;
  const slideCount = slides.length;
  let autoScrollInterval;
  
  // Debug info - remove in production
  console.log('Slider initialized with ' + slideCount + ' slides');
  
  // Hide navigation elements if there's only one slide
  if (slideCount <= 1) {
    const carouselControls = document.querySelector('.carousel-controls');
    if (carouselControls) carouselControls.style.display = 'none';
    // No need to set up auto-scroll or event listeners
    return;
  }
  
  // Start auto-scrolling
  function startAutoScroll() {
    // Clear any existing interval first
    clearInterval(autoScrollInterval);
    
    // Set new interval for auto-scrolling
    autoScrollInterval = setInterval(function() {
      const nextIndex = (currentIndex + 1) % slideCount;
      console.log('Auto-advancing to slide ' + (nextIndex + 1));
      goToSlide(nextIndex);
    }, 3000); // Change slide every 5 seconds
    
    console.log('Autoplay started');
  }
  
  // Initialize auto-scroll immediately
  startAutoScroll();
  
  // Go to specific slide
  function goToSlide(index) {
    // Ensure the index is valid
    if (index < 0 || index >= slideCount) {
      console.error('Invalid slide index: ' + index);
      return;
    }
    
    // Apply transition
    slidesContainer.style.transform = `translateX(-${index * 100}%)`;
    currentIndex = index;
    console.log('Moved to slide ' + (index + 1));
  }
  
  // Previous slide
  if (prevBtn) {
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const prevIndex = (currentIndex - 1 + slideCount) % slideCount;
      goToSlide(prevIndex);
      resetAutoScroll();
      console.log('Previous button clicked, moved to slide ' + (prevIndex + 1));
    });
  }
  
  // Next slide
  if (nextBtn) {
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const nextIndex = (currentIndex + 1) % slideCount;
      goToSlide(nextIndex);
      resetAutoScroll();
      console.log('Next button clicked, moved to slide ' + (nextIndex + 1));
    });
  }
  
  // Reset auto-scroll timer
  function resetAutoScroll() {
    clearInterval(autoScrollInterval);
    startAutoScroll();
    console.log('Autoplay reset');
  }
  
  // Pause auto-scroll on hover
  slidesContainer.addEventListener('mouseenter', function() {
    clearInterval(autoScrollInterval);
    console.log('Autoplay paused on hover');
  });
  
  // Resume auto-scroll when mouse leaves
  slidesContainer.addEventListener('mouseleave', function() {
    startAutoScroll();
    console.log('Autoplay resumed after hover');
  });
  
  // Force first slide to be visible initially
  slides[0].style.display = 'block';
  
  // Set initial state
  goToSlide(0);
  console.log('Initial slide set');
});